import { render, staticRenderFns } from "./Front.vue?vue&type=template&id=21eb9b3b&scoped=true&"
import script from "./Front.vue?vue&type=script&lang=js&"
export * from "./Front.vue?vue&type=script&lang=js&"
import style0 from "./Front.vue?vue&type=style&index=0&id=21eb9b3b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21eb9b3b",
  null
  
)

export default component.exports